import SkeletonCardXL from "./SkeletonCardXL"

const SkeletonCardMXL = SkeletonCardXL

export default SkeletonCardMXL
